import { Badge, type ColorScheme } from "@/deps/ui-library";
import type { JournalStatus } from "@/api/types";

const STATUS: Record<JournalStatus, { label: string; scheme: ColorScheme }> = {
  draft: { label: "Draft", scheme: "default" },
  posted: { label: "Posted", scheme: "success" },
  discarded: { label: "Discarded", scheme: "default" },
};

export function JournalStatusBadge({ status }: { status: JournalStatus }) {
  return (
    <Badge colorScheme={STATUS[status].scheme} size="sm">
      {STATUS[status].label}
    </Badge>
  );
}
